module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('c-confirm-dialog', {
    attrs: {
      "titulo": "Deseja realmente excluir a parceria?"
    },
    on: {
      "yes": function($event) {
        return _vm.excluirParceria()
      }
    },
    model: {
      value: (_vm.dialogConfirmaExclusao),
      callback: function($$v) {
        _vm.dialogConfirmaExclusao = $$v
      },
      expression: "dialogConfirmaExclusao"
    }
  }, [_vm._v("\n  A parceria \"" + _vm._s(this.descricaoParceriaExclusao) + "\" será excluída após clicar na opção \"Sim\".\n")]), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true || _vm.usuarioPROEX === true) ? _c('v-layout', {
    attrs: {
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "instrucao"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n            Informar as parcerias/colaborações: contatos Nacionais e Internacionais efetivamente ocorridos em função da atividade, como convênios, acordos de colaboração, etc.\n          ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaParcerias,
      "search": _vm.search,
      "no-data-text": 'Este projeto não possui parcerias.',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.descricao",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('div', [_c('router-link', {
          attrs: {
            "to": {
              name: 'EditarParceria',
              params: {
                idProjeto: _vm.idProjeto,
                idParceria: props.item.id
              }
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.nome) + "\n        ")])], 1) : _c('div', [_vm._v("\n        " + _vm._s(props.item.nome) + "\n      ")])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [(_vm.administrador === true || (_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1) || _vm.projeto.assessor === true) ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "text": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.botaoExcluirParceria(props.item.id, props.item.nome)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n      Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaParcerias.length) + " parcerias\n    ")]
      }
    }])
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('c-card-footer', {
    attrs: {
      "projeto": this.projeto,
      "extensao": this.extensao,
      "proxima": "AbrangenciaProjeto",
      "editar": "NovaParceria",
      "nome_editar": "Nova parceria",
      "habilitaBotaoGerarPDFAcao": true,
      "habilitaBotaoFinalizarAcao": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-016e0096","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/projeto/projeto-parcerias-tabela.vue
// module id = 491
// module chunks = 0